<template>
	<base-block
		title="Template positions"
		header-bg
	>
		<loading-overlay
			:active="isLoading"
			:can-cancel="true"
		/>
		<template #options>
			<b-button
				type="submit"
				size="sm"
				variant="primary"
				@click="toggleTemplateState"
			>
				Create new
			</b-button>
		</template>
		<b-row>
			<b-col
				v-show="showTemplateState"
				lg="12"
			>
				<div class="d-block text-left">
					<b-form-group
						label-for="example-select"
						label-cols-lg="4"
					>
						<custom-select
							id="example-select"
							v-model="TemplateStateData"
							class="mb-2"
							plain
						>
							<b-form-select-option :value="''">
								Please select an option
							</b-form-select-option>
							<b-form-select-option
								v-for="(opt,id) in options"
								:key="id"
								:value="opt"
							>
								{{ opt }}
							</b-form-select-option>
						</custom-select>
					</b-form-group>
					<b-form-group
						class="form-group"
						label="X-axis"
						label-for="block-form1-name"
						label-cols-lg="4"
					>
						<b-input-group>
							<b-form-input
								v-model.number="singleTemplateState.x_axis"
								type="text"
							/>
						</b-input-group>
					</b-form-group>
					<b-form-group
						class="form-group"
						label="Y-axis"
						label-for="block-form1-name"
						label-cols-lg="4"
					>
						<b-input-group>
							<b-form-input
								v-model.number="singleTemplateState.y_axis"
								type="text"
							/>
						</b-input-group>
					</b-form-group>
					<b-form-group
						class="form-group"
						label="Width"
						label-for="block-form1-name"
						label-cols-lg="4"
					>
						<b-input-group>
							<b-form-input
								v-model.number="singleTemplateState.width"
								type="text"
							/>
						</b-input-group>
					</b-form-group>
					<b-form-group
						class="form-group"
						label="Height"
						label-for="block-form1-name"
						label-cols-lg="4"
					>
						<b-input-group>
							<b-form-input
								v-model.number="singleTemplateState.height"
								type="text"
							/>
						</b-input-group>
					</b-form-group>
					<b-form-group
						class="form-group"
						label="Z-axis"
						label-for="block-form1-name"
						label-cols-lg="4"
					>
						<b-input-group>
							<b-form-input
								v-model.number="singleTemplateState.z_axis"
								type="text"
							/>
						</b-input-group>
					</b-form-group>
					<b-button
						class="mt-3 mb-2"
						@click="saveTemplateState()"
					>
						Add Position
					</b-button>
				</div>
			</b-col>
		</b-row>
		<div
			ref="templatePositionTable"
		/>
	</base-block>
</template>
